import _extends from "@babel/runtime/helpers/esm/extends";
// @ts-nocheck

var isChildList = function isChildList(selectedIndexList, nextSelectedIndexList) {
  if (nextSelectedIndexList.length >= selectedIndexList.length) return false;
  for (var i = 0; i < nextSelectedIndexList.length; i++) {
    if (nextSelectedIndexList[i] !== selectedIndexList[i]) return false;
  }
  return true;
};
var selectedIndexListReducer = function selectedIndexListReducer(state, action) {
  var _action$payload = action.payload,
    payload = _action$payload === void 0 ? {} : _action$payload;
  var nextSelectedIndexList = payload.nextSelectedIndexList,
    openPopup = payload.openPopup,
    keyboard = payload.keyboard,
    nextClickPathList = payload.nextClickPathList,
    selectedIndex = payload.selectedIndex,
    selectedSubIndex = payload.selectedSubIndex;
  var keyEntities = state.keyEntities;
  switch (action.type) {
    case 'setSelectedIndexList':
      if (!nextSelectedIndexList) return _extends({}, state);
      var nextSelectedIndexPath = nextSelectedIndexList.join('-');
      var index = keyEntities.findIndex(function (keyEntity) {
        return keyEntity.key === nextSelectedIndexPath;
      });
      if (index > -1) {
        var node = keyEntities[index];
        if (node.childKey && node.childKey.length === 0) {
          return _extends({}, state, {
            selectedIndexList: nextSelectedIndexList
          });
        } else {
          return _extends({}, state);
        }
      }
    case 'setSelectedKeyForToggleOnly':
      if (!nextSelectedIndexList) return _extends({}, state);
      return _extends({}, state, {
        selectedIndexList: nextSelectedIndexList
      });
    case 'updateSelectedKeyForToggleOnly':
      return _extends({}, state, {
        selectedIndexList: nextSelectedIndexList
      });
    case 'setOpenPopup':
      return _extends({}, state, {
        openPopup: openPopup,
        keyboard: keyboard
      });
    case 'setClickPathList':
      return _extends({}, state, {
        clickPathList: nextClickPathList
      });
    case 'updateSelectedIndexList':
      if (!selectedSubIndex) return _extends({}, state);
      var _nextSelectedIndex = Number(selectedIndex);
      if (_nextSelectedIndex !== Number(state.selectedIndexList[0])) {
        return _extends({}, state, {
          selectedIndexList: [_nextSelectedIndex]
        });
      }
      var _nextSelectedIndexList = [_nextSelectedIndex];
      if (typeof selectedSubIndex === 'number') {
        _nextSelectedIndexList.push(selectedSubIndex);
      } else if (typeof selectedSubIndex === 'object' && selectedSubIndex.length === 0) {
        _nextSelectedIndexList = [];
      } else {
        var _nextSelectedSubIndexList = selectedSubIndex.split('-').map(function (index) {
          return Number(index);
        });
        _nextSelectedIndexList = _nextSelectedIndexList.concat(_nextSelectedSubIndexList);
      }
      if (!isChildList(state.selectedIndexList, _nextSelectedIndexList)) {
        return _extends({}, state, {
          selectedIndexList: _nextSelectedIndexList
        });
      } else {
        return _extends({}, state);
      }
    default:
      return _extends({}, state);
  }
};
export default selectedIndexListReducer;